<template>
    <div class="h-screen flex w-full bg-img">
        <div class="filter"></div>
        <div
            class="content vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
        >
            <slot name="image">
                <img
                    src="@/assets/images/pages/error_default.png"
                    alt="error-graphic"
                    class="mx-auto mb-4 max-w-full"
                />
            </slot>
            <h1 class="sm:mx-0 mx-4 mb-12 text-5xl">
                {{ heading }}
            </h1>

            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16">
                <slot>
                    "Something went wrong... But we're not quite sure exactly what, we would have
                    fixed it had we not been busy baking you this beautiful cake for your
                    birthday!<br /><br />What? It's not your birthday? Well, I suppose it doesn't
                    need to be.<br /><br />You do like cake don't you?<br />NO?!? What kind of
                    monster doesn't like cake?<br />I think I'm going to have to ask you to..."
                </slot>
            </p>

            <vx-button v-if="showNavHome" size="large" to="/">Return Home</vx-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'error',
    props: {
        heading: {
            type: String,
            default: 'The Cake Is A Lie'
        },
        imagePath: {
            type: String,
            default: '@/assets/images/pages/error_default.png'
        },
        showNavHome: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>
.content {
    z-index: 10;
}
.filter {
    background-color: #293336;
    opacity: 0.8;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    backdrop-filter: blur(10px);
}
</style>
